module.exports = __webpack_public_path__ + "img/az_bg_2025_04_25.fcde87ed.png";